export type LayoutDirection = "row" | "column";
export type LayoutAlign = "start" | "center" | "end" | "stretch";
export type LayoutJustify = "start" | "center" | "end" | "between";
export type LayoutGap = "none" | "sm" | "md" | "lg" | "xl";

/** Valeur px des presets gap (Tailwind spacing scale, base 4px). */
export const LAYOUT_GAP_PX: Record<LayoutGap, number> = {
  none: 0,
  sm: 8,
  md: 16,
  lg: 32,
  xl: 48,
};
// Largeur max du conteneur. `full` = 100% ; valeurs px = contenu centré plafonné.
// Anciennes valeurs (`none`/`wide`/`2xl`) conservées en rétro-compat (cf. MAX_WIDTH_CLASS).
export type LayoutMaxWidth =
  | "full"
  | "1024"
  | "1280"
  | "1320"
  | "1440"
  | "1536"
  | "prose";
export type LayoutBackground = "none" | "muted" | "dark";

/** Unités CSS pour la hauteur explicite du conteneur (inline `height`). */
export type ContainerHeightUnit =
  | "px"
  | "vh"
  | "vw"
  | "dvh"
  | "vmin"
  | "vmax"
  | "rem"
  | "em"
  | "%";

export type ContainerHeight = {
  /** `null` = hauteur automatique (aucun `height` CSS). */
  value: number | null;
  unit: ContainerHeightUnit;
};

/** Largeur d'une piste de colonne : parts `fr` ou `auto` (taille du contenu). */
export type ColumnWidthWeight =
  | "auto"
  | "1"
  | "2"
  | "3"
  | "4"
  | "5"
  | "6"
  | "8"
  | "10"
  | "12";

export type ColumnsWidthProps = {
  col1Width?: ColumnWidthWeight;
  col2Width?: ColumnWidthWeight;
  col3Width?: ColumnWidthWeight;
  col4Width?: ColumnWidthWeight;
};

/** Props de largeur par piste pour la Grille (jusqu'à 12 colonnes). */
export type GridWidthProps = ColumnsWidthProps & {
  col5Width?: ColumnWidthWeight;
  col6Width?: ColumnWidthWeight;
  col7Width?: ColumnWidthWeight;
  col8Width?: ColumnWidthWeight;
  col9Width?: ColumnWidthWeight;
  col10Width?: ColumnWidthWeight;
  col11Width?: ColumnWidthWeight;
  col12Width?: ColumnWidthWeight;
};

export type GapInlineStyle = {
  gap?: string;
  columnGap?: string;
  rowGap?: string;
};
